<app-route-name-bar [routeName]="'PAYMENT.PAGE.TITLE'"></app-route-name-bar>
<div class="container">
  <div class="payment-container w-depth">
    <div class="payment-box w-depth">
      <div class="box-header">
        {{"PAYMENT.DIALOG.PAYMENTTEXT"| translate}}
      </div>
      <div class="cards-list">
        <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
        <ul>
          <li *ngFor="let card of cards">
            <div (click)="setDefaultCard(card.id)">
              <div class="icon">
                <i class="mdi mdi-credit-card"></i>
              </div>
              <div class="card-text">
                <span>{{card.brand}}</span> {{'PAYMENT.DIALOG.ENDING' | translate}} <span>{{card.last4}}</span>
              </div>
              <div class="default-icon" *ngIf="defaultCard == card.id">
                <i class="mdi mdi-check"></i>
              </div>
            </div>
            <div class="remove-btn" *ngIf="defaultCard != card.id" (click)="deleteCard(card.id)">
              <i class="mdi mdi-close"></i>
            </div>
          </li>
          <li (click)="openDialog()">
            <div class="icon">
              <i class="mdi mdi-plus"></i>
            </div>
            <div class="card-text">
            <span>
              {{'PAYMENT.DIALOG.ADDTEXT' | translate}}
            </span>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</div>
